import React, { Component, ReactNode } from "react";
import brokenComputerIcon from "img/ErrorBoundary.png";

interface ErrorBoundaryProps {
  children: ReactNode;
  errorMessage?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-row align-items-center text-center justify-content-center">
          <img
            src={brokenComputerIcon}
            alt="Broken computer icon"
            style={{ width: "100px", height: "100px" }}
          />
          <p className="text-xl font-bold">{this.props.errorMessage || "Something went wrong"}</p>
          <img
            src={brokenComputerIcon}
            alt="Broken computer icon"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
